import { SAVE_I140FORMS_SUCCESS,SAVE_I140FORMS_FAILED , SAVE_I140FORMS_STARTED,
  UPDATE_I140FORMS_SUCCESS,UPDATE_I140FORMS_FAILED ,UPDATE_I140FORMS_STARTED,
  GET_I140FORMS_STARTED,GET_I140FORMS_SUCCESS,GET_I140FORMS_FAILED,
  SAVEPDF_I140FORMS_STARTED, SAVEPDF_I140FORMS_SUCCESS,SAVEPDF_I140FORMS_FAILED,
 } from '../actions/VisaCareI140Case';

  
const intialData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};

export const i140FormPdfData = (state = intialData, action: any) => {

  switch (action.type) {
    case SAVEPDF_I140FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVEPDF_I140FORMS_SUCCESS:
      return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVEPDF_I140FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    
    default:
        return state;
    }
    
}
export const visaCareI140FormData = (state = intialData, action: any) => {
  switch (action.type) {
    case SAVE_I140FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVE_I140FORMS_SUCCESS:
    if(action.payload.id===undefined || action.payload.id==="" || action.payload.id===null){
      action.payload="Error Occurs in Input. Pls try Again...";
      alert("Error Occurs in Input. Pls try Again...");
    }else{
      alert("I140Form Data Inserted Successfully... ");
    }
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVE_I140FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    case UPDATE_I140FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_I140FORMS_SUCCESS: 
  /*  if(action.payload.id===undefined || action.payload.id==="" || action.payload.id===null){
      action.payload="Error Occurs in Input. Pls try Again...";
      alert("Error Occurs in Input. Pls try Again...");
    }else{
      alert("I140Form Data Updated Successfully... ");
    }*/
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_I140FORMS_FAILED:
    return {
      ...state,
      isLoading: true 
    };
    case GET_I140FORMS_STARTED:  
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_I140FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_I140FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    default:
        return state;
    }
    
}